import { Table } from '@/components/table/Tables';
import { Column } from 'primereact/column';
import { classNames } from 'primereact/utils';
import style from '../views/program.module.css';

type Group = {
	name: string;
	description: string;
	peopleCount: number;
};

type Props = { groups: Group[] };

const PeopleTable = (props: Props) => {
	const { groups } = props;
	return (
		<Table
			value={groups}
			rowClassName={() => classNames(style.programGroupTableRow)}
			paginatorClassName={classNames(style.programGroupTablePagination)}
			paginator
			rows={5}
			rowsPerPageOptions={[5, 10, 25, 50]}
			pt={{
				wrapper: {
					className: 'rounded-t-xl',
				},
			}}
		>
			<Column
				headerClassName={style.programGroupTableRow}
				field="name"
				header="Group Name"
				body={(rowData) => (
					<div>
						<p className="font-semibold">{rowData.name}</p>
						<p className="text-gray-500 text-xs">
							{rowData.description}
						</p>
					</div>
				)}
				sortable
			/>
			<Column
				headerClassName={style.programGroupTableRow}
				field="peopleCount"
				header="Number of People"
				sortable
			/>
		</Table>
	);
};

export default PeopleTable;
